import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText, FormControlLabel, InputAdornment,
  Modal,
  TextareaAutosize,
  TextField
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { CancelRounded, Save, SaveRounded } from "@material-ui/icons";

export default function EditInspectionPriceModal({
  inspectionType,
  open,
  closeHandler,
  saveHandler,
  priceField = "Price",
  title = "Edit Price for",
  initialPrice = null,
  showEffectiveDate = true
}) {

  if (!inspectionType) {
    return null;
  }

  const [price, setPrice] = useState(null);
  const [updateAll, setUpdateAll] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState("");
  const [useDifferentDate, setUseDifferentDate] = useState(false);

  // Get today's date in YYYY-MM-DD format for default value
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  useEffect(() => {
    setUpdateAll(false);
    setUseDifferentDate(false);
    setEffectiveDate(getTodayDate());
  },[open]);

  const savePrice = () => {
    // Always save with an effective date - either today or the selected date
    const dateToSave = useDifferentDate ? effectiveDate : getTodayDate();
    saveHandler(inspectionType, price, updateAll, dateToSave);
    closeHandler();
  };

  useEffect(() => {
    if (!inspectionType) {
      return;
    }
    // Use initialPrice if provided, otherwise fall back to the specified price field
    const priceValue = initialPrice !== null ? initialPrice : inspectionType[priceField];
    setPrice(priceValue);
  },[inspectionType, initialPrice, priceField]);

  return (
    <>
      <Dialog open={open} onClose={closeHandler} maxWidth='sm' fullWidth={true}>

        <DialogContent>
          <DialogContentText>
            {title} {inspectionType.InspectionType}
          </DialogContentText>

          <div className="tw-mt-1 tw-relative tw-rounded-md tw-shadow-sm">
            <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
              <span className="tw-text-gray-500 sm:tw-text-sm">$</span>
            </div>
            <input
              type="text"
              className="focus:tw-ring-primary focus:tw-border-primary tw-block tw-w-full tw-pl-7 tw-pr-12 sm:tw-text-sm tw-border-gray-300 tw-rounded-md"
              aria-describedby="price-currency"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <div className="tw-absolute tw-inset-y-0 tw-right-0 tw-pr-3 tw-flex tw-items-center tw-pointer-events-none">
              <span className="tw-text-gray-500 sm:tw-text-sm" id="price-currency">
            USD
              </span>
            </div>
          </div>

          <FormControlLabel
            control={<Checkbox value={updateAll} onChange={(e) => {setUpdateAll(e.target.checked);}}/>}
            label="Update all"
          />

          <p className={"tw-text-lg tw-text-danger"}>{updateAll ? <span>This will update every Inspection Type price to ${price} - are you sure?</span> : <span>&nbsp;</span>}</p>

          {showEffectiveDate &&
            <div className="tw-mt-4 tw-border-t tw-pt-4">
              <p className="tw-text-sm tw-text-gray-600 tw-mb-2">
                This price will take effect from <strong>today ({getTodayDate()})</strong>. Previous prices will still apply to earlier inspections.
              </p>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={useDifferentDate}
                    onChange={(e) => setUseDifferentDate(e.target.checked)}
                  />
                }
                label="Use a different effective date"
              />

              {useDifferentDate &&
                <div className="tw-mt-2">
                  <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
                    Effective Date
                  </label>
                  <input
                    type="date"
                    className="focus:tw-ring-primary focus:tw-border-primary tw-block tw-w-full sm:tw-text-sm tw-border-gray-300 tw-rounded-md tw-p-2"
                    value={effectiveDate}
                    onChange={(e) => setEffectiveDate(e.target.value)}
                  />
                  <p className="tw-text-sm tw-text-gray-500 tw-mt-1">
                    This price will apply to inspections submitted on or after this date.
                  </p>
                </div>
              }
            </div>
          }

          <DialogActions className='sm:mt-4'>
            <Button variant={"contained"} onClick={savePrice} color={"primary"} startIcon={<SaveRounded/>}>
                            Save
            </Button>
            <Button variant={"contained"} onClick={closeHandler} color={"secondary"}
              startIcon={<CancelRounded/>}>
                            Cancel
            </Button>
          </DialogActions>

        </DialogContent>

      </Dialog>
    </>
  );
}
